@if (!isDuration15Minutes()) {
  @if(!isImgError) {
    <header 
      class="card__header" 
      [attr.data-header-point-scroll-index]="indexCard()"
    >
      @defer (on viewport) { 
        <img 
          [src]="img()" 
          [attr.alt]="('Imagen' | translate) + ' ' + title()"
          (error)="handleImgError()"
        >
      } @placeholder {
        <img 
          src="/assets/imgs/default-custom-route-img.webp" 
          [attr.alt]="('Imagen' | translate) + ' ' + title()"
        >
      }
    </header>
    
  } @else {
    <header 
      class="card__header card__header--fallback" 
      [attr.data-header-point-scroll-index]="indexCard()"
    >
      <h2 class="ci-heading-h4-semibold">
        {{ title() | translate }}
      </h2>
    </header>
  }
}